<template>
  <section>
    <b-field grouped>
<!--      <b-input @keyup.native.enter="event => onEnter" v-model="keyword" placeholder="Поиск... К примеру Lenovo или 10750H" expanded></b-input>-->
      <b-input v-model="keyword" placeholder="Поиск... К примеру Lenovo или 10750H" expanded></b-input>
      <a v-if="keyword" :href="'/search/' + keyword">
        <p class="control">
          <button class="button is-success">Поиск</button>
        </p>
      </a>
    </b-field>
  </section>
</template>
<script>
import debounce from 'debounce';
import axios from 'axios'

export default {
  name: "Search",
  data() {
    return {
      data: [],
      name: '',
      selected: null,
      isFetching: false,
      MEDIA_URL: process.env.VUE_APP_MEDIA_URL,
      API_URL: process.env.VUE_APP_API_URL,
      available_stock: 0,
      keyword: '',
    }
  },
  methods: {
    getAsyncData: debounce(function () {
      this.data = [];
      this.isFetching = true;
      axios.get(this.API_URL + '/laptops', {
        params: {
          search: this.name,
          limit: 100,
          quantity: this.available_stock
        }
      })
          .then(({data}) => {
            data.results.forEach((item) => this.data.push(item));
            this.isFetching = false
          })
          .catch((error) => {
            this.isFetching = false;
            throw error
          })
    }, 700)
  },
}
</script>
